import { Controller } from "@hotwired/stimulus"
import { coerce } from "../modules/coercion_semantics"

// Live coercion playground for "The .to_i that ate the 0.5". Reads the typed
// value, asks the pure module how each coercion reshapes it, and renders the
// comparison table. Cells that diverge from the true value are flagged inline.
export default class extends Controller {
  static targets = ["input", "rows", "trueValue"]

  connect() {
    this.update()
  }

  update() {
    const { trueDisplay, cells } = coerce(this.inputTarget.value)
    if (this.hasTrueValueTarget) this.trueValueTarget.textContent = trueDisplay
    this.rowsTarget.innerHTML = cells.map(cell => this._row(cell)).join("")
  }

  _row(cell) {
    const base = "padding:6px 10px;text-align:right;"
    const highlight = cell.diverges ? "background:#fef2f2;color:#991b1b;font-weight:600;" : ""
    const marker = cell.diverges ? " ✗" : ""
    return `<tr>
      <td class="font-mono text-sm" style="padding:6px 10px;">${this._escape(cell.label)}</td>
      <td class="font-mono text-sm" style="${base}${highlight}">${this._escape(cell.display)}${marker}</td>
    </tr>`
  }

  _escape(value) {
    const div = document.createElement("div")
    div.textContent = value
    return div.innerHTML
  }
}
